function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M10.2111 12.6667C9.3358 12.6667 8.4963 12.3155 7.87734 11.6904C7.25837 11.0652 6.91064 10.2174 6.91064 9.33333C6.91064 8.44928 7.25837 7.60143 7.87734 6.97631C8.4963 6.35119 9.3358 6 10.2111 6C11.0865 6 11.926 6.35119 12.545 6.97631C13.1639 7.60143 13.5117 8.44928 13.5117 9.33333C13.5117 9.77107 13.4263 10.2045 13.2604 10.6089C13.0946 11.0134 12.8514 11.3808 12.545 11.6904C12.2385 11.9999 11.8746 12.2454 11.4742 12.4129C11.0738 12.5804 10.6446 12.6667 10.2111 12.6667ZM10.2111 0C7.76017 0 5.40958 0.98333 3.67648 2.73367C1.94337 4.48401 0.969727 6.85798 0.969727 9.33333C0.969727 16.3333 10.2111 26.6667 10.2111 26.6667C10.2111 26.6667 19.4526 16.3333 19.4526 9.33333C19.4526 6.85798 18.4789 4.48401 16.7458 2.73367C15.0127 0.98333 12.6621 0 10.2111 0Z",
  fill: "#FFC107"
});

var SvgYellowMarker = function SvgYellowMarker(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 27,
    viewBox: "0 0 20 27",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYellowMarker, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yellowMarker.d5092e0f.svg";
export { ForwardRef as ReactComponent };